import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {
  black,
  chambray,
  cloud,
  onyx,
  onyxLight,
  white,
  wildSand,
} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    backgroundColor: wildSand,
  },
  header: {
    paddingTop: indent * 0.1,
    paddingBottom: indent * 0.5,
  },
  titleText: {
    fontSize: 18,
    lineHeight: 26,
  },
  content: {
    paddingTop: indent * 0.05,
    paddingBottom: indent * 0.4,
  },
  globalProgressRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  globalProgressTrack: {
    width: '68%',
    height: 8,
    borderRadius: 6,
    backgroundColor: cloud,
    marginRight: indent * 0.35,
    overflow: 'hidden',
  },
  globalProgressFill: {
    height: '100%',
    borderRadius: 8,
    backgroundColor: black,
  },
  globalProgressLabel: {
    color: onyx,
    fontSize: 14,
    lineHeight: 18,
    fontWeight: '700',
  },
  periodHeaderRow: {
    flexDirection: 'row',
    alignItems: 'baseline',
    marginTop: indent * 0.45,
  },
  monthText: {
    fontSize: 16,
    lineHeight: 20,
  },
  daysLeftText: {
    marginTop: indent * 0.2,
    marginLeft: indent * 0.25,
    color: onyxLight,
    fontSize: 12,
    lineHeight: 20,
  },
  pqvHeaderText: {
    marginTop: indent * 0.5,
    marginBottom: indent * 0.2,
    color: onyx,
    fontSize: 14,
    lineHeight: 20,
  },
  tierBlock: {
    marginTop: indent * 0.4,
  },
  tierHeaderRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  bonusTitleText: {
    fontSize: 15,
    lineHeight: 18,
  },
  bonusAmountText: {
    marginLeft: indent * 0.35,
    color: onyxLight,
    fontSize: 15,
    lineHeight: 18,
  },
  completeContainer: {
    marginLeft: 'auto',
    flexDirection: 'row',
    alignItems: 'center',
  },
  completeIcon: {
    color: chambray,
    fontSize: 10,
    marginRight: indent * 0.1,
  },
  completeText: {
    color: chambray,
    fontSize: 14,
    lineHeight: 22,
    fontWeight: 500,
  },
  slotsRow: {
    flexDirection: 'row',
    marginTop: indent * 0.2,
  },
  slot: {
    flex: 1,
    height: 44,
    borderRadius: 12,
    borderWidth: 1,
    borderStyle: 'dashed',
    borderColor: onyxLight,
    backgroundColor: wildSand,
    alignItems: 'center',
    justifyContent: 'center',
    marginHorizontal: 2,
  },
  slotInner: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100%',
    minWidth: '100%',
  },
  slotFilled: {
    borderStyle: 'solid',
    borderColor: chambray,
    backgroundColor: chambray,
  },
  slotNumber: {
    color: onyxLight,
    fontSize: 13,
    lineHeight: 15,
    fontWeight: '700',
  },
  filledSlotContent: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  slotNumberFilled: {
    color: white,
    fontSize: 13,
    lineHeight: 15,
    marginRight: indent * 0.12,
    fontWeight: '700',
  },
  slotCheckIcon: {
    color: white,
    fontSize: 10,
  },
  footerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: indent * 0.4,
    paddingBottom: indent * 0.2,
  },
  footerLabelText: {
    color: onyxLight,
    fontSize: 15,
    lineHeight: 22,
  },
  footerValueText: {
    color: '#111111',
    fontSize: 15,
    lineHeight: 22,
  },
});
